const getIntro = () => {
    return `    
const KPIDetailComponent = (props) => {
    const { userView, username, periodicView, evaluationCycleID } = props;
KPIDetailComponent.propTypes = {
    username: PropTypes.string,
    userView: PropTypes.bool,
  periodicView: PropTypes.bool,
  evaluationCycleID: PropTypes.string,
};
export default KPIDetailComponent;
    `;
}

export default getIntro;
